import XLSX from 'xlsx';
import messageErreur from '@/services/general/messageErreur';
import getSizeColumn from '@/services/excel/getSizeColumn';
import messageSucces from '@/services/general/messageSucces';
import generateDataExcel from './generateDataExcel';

export default async function exportListeFacesSelectInVenteTempoToExcel(listeFace, i18n, info) {
  const dataExcel = await generateDataExcel(listeFace, i18n, info);
  if (dataExcel.length === 0) {
    messageErreur(i18n, i18n.t('exportExcelFaceSelect.messages.excelExportErrorNoFace'));
    return;
  }
  const tabSize = await getSizeColumn(dataExcel);
  const listeFacturesSheet = XLSX.utils.json_to_sheet(dataExcel, { skipHeader: true });
  listeFacturesSheet['!cols'] = tabSize;
  listeFacturesSheet['!ref'] = 'A1:AZ' + listeFace.length + 1;
  listeFacturesSheet['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 10 } }];
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, listeFacturesSheet, i18n.t('exportExcelFaceSelect.excelInfo.title'));
  XLSX.writeFile(wb, i18n.t('exportExcelFaceSelect.excelInfo.fileName'));
  messageSucces(i18n.t('exportExcelFaceSelect.messages.sucessCreationExcel'));
}
